export const mediumSpeed = '.3s'
export const slowSpeed = '.6s'
